import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute, { RoleRedirect } from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import AdminLayout from "@/components/layouts/AdminLayout";
import EmployeeLayout from "@/components/layouts/EmployeeLayout";

import AdminOverview from "@/pages/admin/Overview";
import AdminEmployees from "@/pages/admin/Employees";
import AdminAttendance from "@/pages/admin/Attendance";
import AdminLeave from "@/pages/admin/Leave";
import AdminWFH from "@/pages/admin/WFH";
import AdminAnnouncements from "@/pages/admin/Announcements";
import AdminReports from "@/pages/admin/Reports";
import AdminSettings from "@/pages/admin/Settings";
import AdminJobs from "@/pages/admin/Jobs";
import AdminOrgChart from "@/pages/admin/OrgChart";
import AdminCompanies from "@/pages/admin/Companies";
import AdminPayroll from "@/pages/admin/Payroll";
import AdminExpenses from "@/pages/admin/Expenses";
import AdminWhatsApp from "@/pages/admin/WhatsApp";
import KioskScan from "@/pages/kiosk/Scan";

import EmployeeToday from "@/pages/employee/Today";
import MyLeave from "@/pages/employee/MyLeave";
import MyWFH from "@/pages/employee/MyWFH";
import Profile from "@/pages/employee/Profile";
import MyPayslips from "@/pages/employee/MyPayslips";
import MyExpenses from "@/pages/employee/MyExpenses";

import Meetings from "@/pages/Meetings";
import RoomAvailability from "@/pages/RoomAvailability";
import TelephoneExtensions from "@/pages/TelephoneExtensions";

import CareersHome from "@/pages/careers/CareersHome";
import JobDetail from "@/pages/careers/JobDetail";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<RoleRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Public careers */}
          <Route path="/careers" element={<CareersHome />} />
          <Route path="/careers/:id" element={<JobDetail />} />
          <Route path="/c/:slug/careers" element={<CareersHome />} />
          <Route path="/c/:slug/careers/:id" element={<JobDetail />} />

          {/* Public kiosk (face-scanner) — token-gated, unauthenticated */}
          <Route path="/kiosk/scan" element={<KioskScan />} />

          {/* Admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allow="admin">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminOverview />} />
            <Route
              path="employees"
              element={
                <ProtectedRoute roles={["super_admin", "hr"]}>
                  <AdminEmployees />
                </ProtectedRoute>
              }
            />
            <Route path="org" element={<AdminOrgChart />} />
            <Route path="attendance" element={<AdminAttendance />} />
            <Route path="leave" element={<AdminLeave />} />
            <Route path="wfh" element={<AdminWFH />} />
            <Route path="meetings" element={<div className="p-6"><Meetings /></div>} />
            <Route path="rooms" element={<RoomAvailability />} />
            <Route path="extensions" element={<TelephoneExtensions />} />
            <Route path="announcements" element={<AdminAnnouncements />} />
            <Route path="reports" element={<AdminReports />} />
            <Route
              path="payroll"
              element={
                <ProtectedRoute roles={["super_admin", "hr"]}>
                  <AdminPayroll />
                </ProtectedRoute>
              }
            />
            <Route path="expenses" element={<AdminExpenses />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route
              path="companies"
              element={
                <ProtectedRoute roles={["super_admin", "hr"]}>
                  <AdminCompanies />
                </ProtectedRoute>
              }
            />
            <Route path="whatsapp" element={<AdminWhatsApp />} />
            <Route
              path="settings"
              element={
                <ProtectedRoute roles={["super_admin", "hr"]}>
                  <AdminSettings />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Employee */}
          <Route
            path="/employee"
            element={
              <ProtectedRoute allow="employee">
                <EmployeeLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<EmployeeToday />} />
            <Route path="leave" element={<MyLeave />} />
            <Route path="wfh" element={<MyWFH />} />
            <Route path="payslips" element={<MyPayslips />} />
            <Route path="expenses" element={<MyExpenses />} />
            <Route path="meetings" element={<Meetings />} />
            <Route path="rooms" element={<RoomAvailability />} />
            <Route path="extensions" element={<TelephoneExtensions />} />
            <Route path="profile" element={<Profile />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
